import {
  BranchesOutlined,
  DownOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import { Col, Collapse, Divider, Modal, Row, Select, Tabs, Tag } from 'antd';
import { DollarSign, DownloadIcon, SendApproval } from 'assets/svg';
import { MainLayout } from 'components';
import Button from 'components/Button';
import React, { useEffect, useState } from 'react';
import pageTitleStore from 'store/pageTitleStore';
import type { CollapseProps, MenuProps } from 'antd';
import type { TabsProps } from 'antd';
import { Content } from 'antd/es/layout/layout';
import PlantAllocateTab1 from 'components/Modules/PlantAllocate/PlantAllocateTab1';
import PlantAllocateTab2 from 'components/Modules/PlantAllocate/PlantAllocateTab2';
import PlantAllocateTab3 from 'components/Modules/PlantAllocate/PlantAllocateTab3';
import DropdownButton from 'components/DropdownButton';
import PlantDeclareModalCreate from 'components/Modules/Allocated/PlantAllocateDeclare/PlantDeclareModalCreate';
import handleError401 from 'utils/handleError401';
import AllocateApi from 'apis/Allocate';
import CapitalBranchApi from 'apis/AllocateApi';
import { useUser } from 'contexts/User';
import { useMutation } from 'react-query';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import { useHistory } from 'react-router-dom';
import { openNotificationWithIcon } from 'utils/notification';
import CapitalApi from 'apis/CapitalApi';
import useQueryParam from 'hooks/useQueryPrams';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { ColumnsType } from 'antd/es/table';
import ExportExcel from './ExportExcel';
import * as XLSX from 'xlsx';
import CartApi from 'apis/CartApi';
import { headerCapitalBranch } from 'constants/exportCapitalBranch';
import { headerDeclareCapitalBranch } from 'constants/exportDeclareCapitalBranch';
import { headerCabinet } from 'constants/exportCabinet';
import generateData from 'components/generateData';
import formatDate from 'utils/formatDate';

export default function PlantAllocateView() {
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const { user } = useUser();
  const history = useHistory();
  const [year, setYear] = useState<number>(new Date().getFullYear());
  const [isCapitalYearLoaded, setIsCapitalYearLoaded] = useState(false);
  useEffect(() => {
    if (!user?.branch_code) {
      setIsCapitalYearLoaded(true);
      return;
    }

    const fetchMaxCapitalYear = async () => {
      try {
        const response = await CapitalBranchApi.getMaxCapitalYear(
          user?.branch_code
        );
        const maxCapitalYear = response?.data?.max_capital_year;
        if (maxCapitalYear) {
          const parsedYear = Number(maxCapitalYear);
          if (!Number.isNaN(parsedYear)) {
            setYear(parsedYear);
          }
        }
      } catch (error: any) {
        if (error?.response?.status === 401) {
          handleError401();
        }
      }
      setIsCapitalYearLoaded(true);
    };

    fetchMaxCapitalYear();
  }, [user?.branch_code]);
  const [detailCapitalShop, setDetailCapitalShop] = useState<any>();
  const [dataExport, setDataExport] = useState<any>();
  const [nameFileExport, setNameFileExport] = useState<any>();
  const [exportAction, setExportAction] = useState<boolean>(false);
  const { Option } = Select;

  const [isBtnEnabled, setIsBtnEnabled] = useState<boolean>(true);
  const [IsModalDeclareAllocateOpen, setIsModalDeclareAllocateOpen] =
    useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  const { mutate: getDetailCapitalShop, isLoading: isLoading } = useMutation(
    ['getDetail', detailCapitalShop, user],
    () =>
      AllocateApi.getDetailCapitalShop({
        shop_id: user?.plantId,
        capital_year: year,
      }),
    {
      onSuccess: (response) => {
        setDetailCapitalShop(response.data);
        if (response.data?.status === 0 || response.data?.status === 3) {
          setIsBtnEnabled(true);
        } else {
          setIsBtnEnabled(false);
        }
      },
      onError: (error: any) => {
        setDetailCapitalShop(undefined);
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );

  useEffect(() => {
    if (!isCapitalYearLoaded) {
      return;
    }
    setTitle(`Phân bổ vốn tồn ${year}`);
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="">Chi nhánh</a>
          </p>
        ),
      },
      {
        title: (
          <p>
            <a>Vốn tồn cửa hàng</a>{' '}
          </p>
        ),
      },
      {
        title: <a>Phân bổ vốn tồn {year}</a>,
      },
    ]);
    if (user?.plantId) {
      getDetailCapitalShop();
    }
  }, [year, user?.plantId, isCapitalYearLoaded]);

  useEffect(() => {
    if (exportAction == true && (dataExport != null || dataExport != undefined))
      generateExcel(dataExport);
  }, [dataExport]);

  const IsCapitalDeclare =
    detailCapitalShop?.capital_ratio === null ||
    detailCapitalShop?.capital_ratio == undefined
      ? false
      : true;

  const tableItems: TabsProps['items'] = [
    {
      key: '1',
      label: 'Phân bố tỷ trọng vốn tồn',
      children: detailCapitalShop &&
        detailCapitalShop.capital_ratio &&
        detailCapitalShop.capital_ratio_pof && (
          <PlantAllocateTab1 detailCapitalShop={detailCapitalShop} />
        ),
    },
    {
      key: '2',
      label: 'Khai báo tủ kinh doanh',
      children: detailCapitalShop && (
        <PlantAllocateTab2
          id={detailCapitalShop.id}
          year={year}
          shop_id={undefined}
        />
      ),
    },
    {
      key: '3',
      label: 'Khai báo tỷ trọng vốn theo dòng hàng',
      children: detailCapitalShop && (
        <PlantAllocateTab3 cap_shop_id={detailCapitalShop.id} />
      ),
    },
  ];

  const items: CollapseProps['items'] = [
    {
      key: '1',
      label: (
        <div className="flex items-center">
          <Tag color="#00538F" className="custom-tag">
            <span className="text-base font-bold">Mới tạo</span>
          </Tag>
          <p className="text-xl font-bold">Phân bổ vốn tồn {year}</p>
        </div>
      ),
      children: (
        <div className="px-4">
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="space-between"
            className="mb-2"
          >
            <Col span={8}>
              <Row className="my-1" align={'middle'}>
                <Col span={2}>
                  <DollarSign />
                </Col>
                <Col span={22}>Mã cửa hàng</Col>
              </Row>
              <Row>
                <Col span={22} offset={2}>
                  {user?.plantCode || '-'}
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row className="my-1" align={'middle'}>
                <Col span={2}>
                  <DollarSign />
                </Col>
                <Col span={22}>Tên cửa hàng</Col>
              </Row>
              <Row>
                <Col span={22} offset={2}>
                  {user?.plantName || '-'}
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row className="my-1" align={'middle'}>
                <Col span={2}>
                  <DollarSign />
                </Col>
                <Col span={22}>Ngày phân bổ</Col>
              </Row>
              <Row>
                <Col span={22} offset={2}>
                  {detailCapitalShop == null ||
                  detailCapitalShop.created_at == null
                    ? ' - '
                    : formatDate(detailCapitalShop.created_at)}
                </Col>
              </Row>
            </Col>
          </Row>

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="start"
            className="mb-3"
          >
            <Col span={8}>
              <Row className="my-1" align={'middle'}>
                <Col span={2}>
                  <DollarSign />
                </Col>
                <Col span={22}>Vốn phân bổ</Col>
              </Row>
              <Row>
                <Col span={22} offset={2}>
                  {detailCapitalShop == null ||
                  detailCapitalShop.capital_from_branch_min == null
                    ? ' - '
                    : formatCurrencyVND(
                        detailCapitalShop.capital_from_branch_min
                      ) +
                      ' - ' +
                      formatCurrencyVND(
                        detailCapitalShop.capital_from_branch_max
                      )}
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row className="my-1" align={'middle'}>
                <Col span={2}>
                  <DollarSign />
                </Col>
                <Col span={22}>Vốn đăng ký</Col>
              </Row>
              <Row>
                <Col span={22} offset={2}>
                  {detailCapitalShop == null ||
                  detailCapitalShop.capital_min == null
                    ? ' - '
                    : formatCurrencyVND(detailCapitalShop.capital_min) +
                      ' - ' +
                      formatCurrencyVND(detailCapitalShop.capital_max)}
                </Col>
              </Row>
            </Col>
          </Row>

          <Divider />

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="start">
            <Col span={8}>
              <Row className="my-1" align={'middle'}>
                <Col span={2}>
                  <DollarSign />
                </Col>
                <Col span={22}>Người tạo</Col>
              </Row>
              <Row>
                <Col span={22} offset={2}>
                  {detailCapitalShop == null ||
                  detailCapitalShop.created_by == null
                    ? ' - '
                    : detailCapitalShop.created_by}
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row className="my-1" align={'middle'}>
                <Col span={2}>
                  <DollarSign />
                </Col>
                <Col span={22}>Email</Col>
              </Row>
              <Row>
                <Col span={22} offset={2}>
                  {detailCapitalShop == null || detailCapitalShop.email == null
                    ? ' - '
                    : detailCapitalShop.email}
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      ),
    },
  ];
  // const itemsDroprown_downloadBtn: MenuProps['items'] = [
  //   {
  //     label: 'Phân bố tỉ trọng vốn tồn',
  //     key: '1',
  //   },
  //   {
  //     label: 'Khai báo tủ kinh doanh',
  //     key: '2',
  //   },
  //   {
  //     label: 'Phân bố tỉ trọng vốn theo dòng hàng',
  //     key: '3',
  //   },
  // ];
  const itemsDroprown_declareBtn: MenuProps['items'] = [
    {
      label: 'Phân bố tỉ trọng vốn tồn',
      key: '1',
      onClick: () => {
        setIsModalDeclareAllocateOpen(true);
      },
    },
    ...(IsCapitalDeclare
      ? [
          {
            label: 'Khai báo tủ kinh doanh',
            key: '2',
            onClick: () => {
              if (detailCapitalShop) {
                history.push(
                  `/plants-allocate/createCabinet/${detailCapitalShop.id}`,
                  { detailCapitalShop: detailCapitalShop }
                );
              } else {
                openNotificationWithIcon(
                  'error',
                  'Vui lòng phân bổ tỉ trọng vốn tồn'
                );
              }
            },
          },
          {
            label: 'Phân bố tỉ trọng vốn theo dòng hàng',
            key: '3',
            onClick: () => {
              if (detailCapitalShop) {
                history.push(
                  `/plants-allocate/createAllocateGoods/${detailCapitalShop.id}`
                );
              } else {
                openNotificationWithIcon(
                  'error',
                  'Vui lòng phân bổ tỉ trọng vốn tồn'
                );
              }
            },
          },
        ]
      : []),
  ];

  const updateCapitalStatus = () => {
    if (detailCapitalShop) {
      setLoading(true);
      CapitalApi.putUpdateStatus({
        list_capital_id: [detailCapitalShop?.id],
        status: 1,
        reject_reason: '',
      })
        .then((res) => {
          setLoading(false);
          openNotificationWithIcon('success', 'Gửi yêu cầu thành công');
          location.reload();
          // history.push(`/plants-allocate`);
        })
        .catch((err) => {
          setLoading(false);
          openNotificationWithIcon('error', err.toString());
        });
    } else {
      openNotificationWithIcon(
        'error',
        'Vui lòng phân bổ trước khi gửi phê duyệt'
      );
    }
  };

  function getYears() {
    const currentYear = new Date().getFullYear();
    const minYear = Math.min(currentYear - 5, year);
    const maxYear = Math.max(currentYear + 5, year);
    const years = [];

    for (let loopYear = minYear; loopYear <= maxYear; loopYear++) {
      years.push(loopYear);
    }

    return years;
  }

  const handleCancel = () => {
    setIsModalDeclareAllocateOpen(false);
    getDetailCapitalShop();
  };

  const renderPopup = () => {
    return (
      <PlantDeclareModalCreate
        detailCapitalShop={detailCapitalShop}
        min={detailCapitalShop?.capital_from_branch_min || 0}
        max={detailCapitalShop?.capital_from_branch_max || 0}
        shop_id={user?.plantId}
        IsCapitalDeclare={IsCapitalDeclare}
        // min={1000000000}
        // max={5000000000}
        // shop_id={402}
        capital_year={year}
        onCancel={handleCancel}
      />
    );
    // if (
    //   detailCapitalShop === undefined ||
    //   detailCapitalShop.capital_ratio_pof === undefined ||
    //   detailCapitalShop.capital_ratio_pof === null ||
    //   detailCapitalShop.capital_ratio_pof.length == 0
    // ) {
    //   return (
    //     <PlantDeclareModalCreate
    //       min={detailCapitalShop?.capital_from_branch_min || 0}
    //       max={detailCapitalShop?.capital_from_branch_max || 0}
    //       shop_id={user?.plantId}
    //       // min={1000000000}
    //       // max={5000000000}
    //       // shop_id={402}
    //       capital_year={year}
    //       onCancel={handleCancel}
    //     />
    //   );
    // } else {
    //   return (
    //     <PlantDeclareModalUpdate
    //       onCancel={handleCancel}
    //       year={year}
    //       detailCapital={detailCapitalShop}
    //     />
    //   );
    // }
  };

  const itemsDroprown_exportBtn: MenuProps['items'] = [
    {
      label: 'Vốn',
      key: '1',
      onClick: () => {
        handleExport('von');
      },
    },
    {
      label: 'Khai báo vốn',
      key: '2',
      onClick: () => {
        handleExport('khaiBaoVon');
      },
    },
    {
      label: 'Khai báo tủ',
      key: '3',
      onClick: () => {
        handleExport('khaiBaoTu');
      },
    },
  ];

  function generateExcel(dataExport: any) {
    const data = [];
    let headerFile: ColumnsType<any> = [];
    // create title
    if (nameFileExport == 'Vốn') {
      setNameFileExport('Vốn');
      const header = headerCapitalBranch.map((column) => {
        return column.title;
      });
      headerFile = headerCapitalBranch;
      data.push(header);
    } else if (nameFileExport == 'Khai Báo Vốn') {
      setNameFileExport('Khai Báo Vốn');
      const header = headerDeclareCapitalBranch.map((column) => {
        return column.title;
      });
      data.push(header);
      headerFile = headerDeclareCapitalBranch;
    } else if (nameFileExport == 'Khai Báo Tủ') {
      setNameFileExport('Khai Báo Tủ');
      const header = headerCabinet.map((column) => {
        return column.title;
      });
      data.push(header);
      headerFile = headerCabinet;
    }

    const itemExport = Object.values(dataExport);

    // create data
    const rowData = generateData({
      data: data,
      dataExport: itemExport,
      header: headerFile,
      user: user,
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(rowData);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${nameFileExport}.xlsx`);
  }

  const { mutate: exportVon, isLoading: vonLoading } = useMutation(
    CartApi.exportVon,
    {
      onSuccess: (data: any) => {
        if (data.status === 'success') {
          setDataExport({ ...dataExport, ...data?.data });
        } else {
          openNotificationWithIcon('success', 'Export thành công');
        }
      },
      onError: (error) => {
        console.log('er: ', error);
        openNotificationWithIcon('error', 'Export thất bại');
      },
    }
  );

  const { mutate: exportKhaiBaoTu, isLoading: khaiBaoTuLoading } = useMutation(
    CartApi.exportKhaiBaoTu,
    {
      onSuccess: (data: any) => {
        if (data.status === 'success') {
          setDataExport({ ...dataExport, ...data?.data });
        } else {
          openNotificationWithIcon('success', 'Export thành công');
        }
      },
      onError: (error) => {
        console.log('er: ', error);
        openNotificationWithIcon('error', 'Export thất bại');
      },
    }
  );

  const { mutate: exportKhaiBaoVon, isLoading: khaiBaoVonLoading } =
    useMutation(CartApi.exportKhaiBaoVon, {
      onSuccess: (data: any) => {
        if (data.status === 'success') {
          setDataExport({ ...dataExport, ...data?.data });
        } else {
          openNotificationWithIcon('success', 'Export thành công');
        }
      },
      onError: (error) => {
        console.log('er: ', error);
        openNotificationWithIcon('error', 'Export thất bại');
      },
    });

  const handleExport = async (btn: any) => {
    setDataExport(null);
    if (btn == 'von') {
      setNameFileExport('Vốn');
      exportVon([user?.plantCode]);
      setExportAction(true);
    } else if (btn == 'khaiBaoVon') {
      setNameFileExport('Khai Báo Vốn');
      exportKhaiBaoVon([user?.plantCode]);
      setExportAction(true);
    } else if (btn == 'khaiBaoTu') {
      setNameFileExport('Khai Báo Tủ');
      const store_ids = [user?.plantCode];
      const param = {
        capital_year: year,
        status: detailCapitalShop?.status,
        store_ids: store_ids,
      };
      exportKhaiBaoTu(param);
      setExportAction(true);
    }
  };

  return (
    <MainLayout
      isLoading={
        (isLoading && loading) ||
        vonLoading ||
        khaiBaoTuLoading ||
        khaiBaoVonLoading
      }
    >
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="space-between">
        <Col span={8}>
          <Select
            onChange={(value: any) => {
              setYear(value);
              setTitle(`Phân bổ vốn tồn ${value}`);
            }}
            value={year}
            defaultValue={year}
            size="middle"
            className="w-28"
          >
            {getYears().map((item: any) => (
              <Option key={item} value={item}>
                {item}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={16}>
          <Row justify="end" className="gap-4">
            <Col>
              {/* <ExportExcel
                shop_id={user?.plantId}
                capital_year={year}
                detailCapitalShop={detailCapitalShop}
              /> */}
              <DropdownButton
                bgColor="bg-primary-50"
                items={itemsDroprown_exportBtn}
                customClass="fix-border-radius mr-2"
              >
                <DownloadOutlined />
                Tải file excel
              </DropdownButton>
            </Col>

            {detailCapitalShop?.status === 1 ? (
              <Col>
                <DropdownButton
                  bgColor="bg-gray-300"
                  disabled
                  items={itemsDroprown_declareBtn}
                >
                  <BranchesOutlined /> Khai báo
                </DropdownButton>
              </Col>
            ) : (
              <Col>
                <DropdownButton items={itemsDroprown_declareBtn}>
                  <BranchesOutlined /> Khai báo
                </DropdownButton>
              </Col>
            )}

            {isBtnEnabled === true ? (
              <Col>
                {' '}
                <Button onClick={updateCapitalStatus}>
                  {' '}
                  <SendApproval /> Yêu cầu phê duyệt
                </Button>
              </Col>
            ) : (
              <Col>
                {' '}
                <Button
                  // customClass="opacity-80"
                  disabled
                  bgColor="bg-gray-300"
                  onClick={updateCapitalStatus}
                >
                  {' '}
                  <SendApproval /> Yêu cầu phê duyệt
                </Button>
              </Col>
            )}
          </Row>
        </Col>
      </Row>

      <Row className="my-5" justify="center">
        <Col span={24} className="bg-white p-4">
          <Collapse
            expandIconPosition="right"
            ghost
            expandIcon={({ isActive }) => (
              <DownOutlined rotate={isActive ? 180 : 0} />
            )}
            size="small"
            items={items}
          />
        </Col>
      </Row>

      <Modal
        open={IsModalDeclareAllocateOpen}
        width="70%"
        footer={null}
        className="modal-plant-allocate"
        onCancel={() => {
          setIsModalDeclareAllocateOpen(false);
        }}
        title={<p className="text-lg font-bold">Phân bố tỷ trọng vốn tồn</p>}
      >
        {renderPopup()}
      </Modal>

      <Content className="main-content">
        {/* <div className="flex"> */}
        <Tabs
          defaultActiveKey="1"
          items={tableItems}
          tabBarExtraContent={
            <span
              className="border border-solid boder-primary-50 rounded-lg font-sans text-sm py-1 px-2 leading-5 bg-gray-100 uppercase"
              style={{ color: '#4da6ff' }}
            >
              {detailCapitalShop?.status == 0
                ? 'Mới tạo'
                : detailCapitalShop?.status == 1
                ? 'Chờ phê duyệt'
                : detailCapitalShop?.status == 2
                ? 'Đã duyệt'
                : detailCapitalShop?.status == 3
                ? 'Từ chối'
                : 'Chưa tạo'}
            </span>
          }
          onChange={() => {
            history.push('/plants-allocate');
          }}
        />
      </Content>
    </MainLayout>
  );
}
